import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Plus, X } from 'lucide-react';

const TemplateVariables = ({ variables, onChange }) => {
  const [newVariable, setNewVariable] = useState({ name: '', description: '', defaultValue: '', required: false });

  const handleAddVariable = () => {
    if (newVariable.name.trim()) {
      const variable = {
        name: newVariable.name.trim(),
        description: newVariable.description.trim(),
        defaultValue: newVariable.defaultValue.trim(),
        required: newVariable.required
      };
      
      onChange([...variables, variable]);
      setNewVariable({ name: '', description: '', defaultValue: '', required: false });
    }
  };

  const handleRemoveVariable = (index) => {
    const updatedVariables = variables.filter((_, i) => i !== index);
    onChange(updatedVariables);
  };

  const handleVariableChange = (index, field, value) => {
    const updatedVariables = variables.map((variable, i) => 
      i === index ? { ...variable, [field]: value } : variable
    );
    onChange(updatedVariables);
  };

  return (
    <div>
      <h6 className="mb-3">Template Variables</h6>
      
      {/* Existing Variables */}
      {variables.map((variable, index) => (
        <div key={index} className="border rounded p-3 mb-3 bg-light">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h6 className="mb-0">{variable.name}</h6>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => handleRemoveVariable(index)}
            >
              <X size={14} />
            </Button>
          </div>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label className="small">Description</Form.Label>
                <Form.Control
                  size="sm"
                  value={variable.description}
                  onChange={(e) => handleVariableChange(index, 'description', e.target.value)}
                  placeholder="What is this variable for?"
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label className="small">Default Value</Form.Label>
                <Form.Control
                  size="sm"
                  value={variable.defaultValue}
                  onChange={(e) => handleVariableChange(index, 'defaultValue', e.target.value)}
                  placeholder="Default value"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group className="mb-2">
                <Form.Label className="small">Required</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={variable.required}
                  onChange={(e) => handleVariableChange(index, 'required', e.target.checked)}
                  className="mt-2"
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}

      {/* Add New Variable */}
      <div className="border rounded p-3 bg-light">
        <h6 className="mb-3">Add New Variable</h6>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-2">
              <Form.Label className="small">Variable Name *</Form.Label>
              <Form.Control
                size="sm"
                value={newVariable.name}
                onChange={(e) => setNewVariable(prev => ({ ...prev, name: e.target.value }))}
                placeholder="e.g., topic, audience"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-2">
              <Form.Label className="small">Description</Form.Label>
              <Form.Control
                size="sm"
                value={newVariable.description}
                onChange={(e) => setNewVariable(prev => ({ ...prev, description: e.target.value }))}
                placeholder="What is this variable for?"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-2">
              <Form.Label className="small">Default Value</Form.Label>
              <Form.Control
                size="sm"
                value={newVariable.defaultValue}
                onChange={(e) => setNewVariable(prev => ({ ...prev, defaultValue: e.target.value }))}
                placeholder="Default"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-2">
              <Form.Label className="small">Required</Form.Label>
              <Form.Check
                type="checkbox"
                checked={newVariable.required}
                onChange={(e) => setNewVariable(prev => ({ ...prev, required: e.target.checked }))}
                className="mt-2"
              />
            </Form.Group>
          </Col>
        </Row>
        
        <Button
          variant="outline-primary"
          size="sm"
          onClick={handleAddVariable}
          disabled={!newVariable.name.trim()}
        >
          <Plus size={14} className="me-1" />
          Add Variable
        </Button>
      </div>
    </div>
  );
};

export default TemplateVariables;
